import axios from 'axios';
import {AUTH_BASE_URL, DATA_BASE_URL} from '../config';
import {doAuthFlow, getAccess} from './auth';

export const authBaseUrl = AUTH_BASE_URL;
export const dataBaseUrl = DATA_BASE_URL;

export const apiRequest = async (baseURL, url, params = {}) => {

    let headers = {};

    if (params.withAuth) {

        // refresh the token if needed
        await doAuthFlow();

        let a = getAccess();
        headers = {'Authorization': `Bearer ${a ? a.token : null}`};
    }

    try {
        const response = await axios({
            baseURL,
            url: url,
            headers,
            ...params
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            if (error.response.data.details) {
                console.log(error.response.data.details);
            }
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
        }
        throw error;
    }
};
